import {
  AssetClassColour,
  AssetClassColourArray,
  AssetClassNameArray,
  AssetClassNames,
} from "./enums/AssetClassType";
import { Placements } from "./enums/Placements";

class AssetClassSummaryController
  implements angular.IOnInit, angular.IOnChanges
{
  // Properties are passed to inner components
  public assetClasses: { name: string; total: number }[]; //AssetClassTotal[]
  public assetClassColourArray: string[] = AssetClassColourArray;
  public chartClass: string;
  public displayCurrency: string; // Possible Enum: DisplayCurrencies or Currencies
  public showLabels: boolean;
  public showIndicators: boolean;

  // Used for this component
  public listPosition: Placements;

  /** @ngInject */
  constructor() {}

  $onInit(): void {
    this.listPosition = this.listPosition || Placements.Left;
  }

  $onChanges(onChangesObj: angular.IOnChangesObject): void {
    if (
      onChangesObj.assetClasses.currentValue &&
      onChangesObj.assetClasses.currentValue !==
        onChangesObj.assetClasses.previousValue
    ) {
      this.assetClassColourArray = onChangesObj.assetClasses.currentValue
        .filter((a) => a.total)
        .map((a) => {
          if (a.name == AssetClassNames.PRECIOUS_METALS) {
            return AssetClassColour["PRECIOUS_METALS"];
          }
          return AssetClassColour[a.name.replace(" ", "_").toUpperCase()];
        });
    }
  }
}

export const assetClassSummary: angular.IComponentOptions = {
  controller: AssetClassSummaryController,
  template: require("./assetClassSummary.component.html"),
  bindings: {
    assetClasses: "<",
    displayCurrency: "<",
    listPosition: "<",
    showLabels: "<",
    showIndicators: "<",
    chartClass: "=",
  },
};



// WEBPACK FOOTER //
// ./src/app/common/assetClassSummary.component.ts